import { EntityConfiguration, GroupConfig } from '../../modules/dto'
import { ConfigState, configStoreKey } from './config.state'
import { createSelector, MemoizedSelector, createFeatureSelector } from '@ngrx/store'

const getConfigs = (state: ConfigState): Record<string, EntityConfiguration> => state.configs
const getGroupConfigs = (state: ConfigState): Record<string, GroupConfig> => state.groupConfigs

export const selectConfigsState: MemoizedSelector<object, ConfigState> =
  createFeatureSelector<ConfigState>(configStoreKey)
export const selectConfigs: MemoizedSelector<object, Record<string, EntityConfiguration>> = createSelector(
  selectConfigsState,
  getConfigs
)
export const selectGroupConfigs: MemoizedSelector<object, Record<string, GroupConfig>> = createSelector(
  selectConfigsState,
  getGroupConfigs
)

// selector factory since parameterized selectors will be deprecated with ngrx 12
// https://github.com/ngrx/platform/issues/2980
export const selectConfigForType = (type: string): MemoizedSelector<object, EntityConfiguration> =>
  createSelector(selectConfigs, (configs) => (!!configs ? configs[type] : null))
